/**
 * @generated SignedSource<<cb3d49ec1361822d0b50dc23ab66269c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type JiraProjectStyle = "COMPANY_MANAGED_PROJECT" | "TEAM_MANAGED_PROJECT" | "%future added value";
export type JiraProjectType = "BUSINESS" | "CUSTOMER_SERVICE" | "PRODUCT_DISCOVERY" | "SERVICE_DESK" | "SOFTWARE" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type NavHeader_project$data = {
  readonly mostRecentlyViewedBoard?: {
    readonly " $fragmentSpreads": FragmentRefs<"HorizontalNavBoardHeader_board">;
  } | null | undefined;
  readonly projectStyle: JiraProjectStyle;
  readonly projectType: JiraProjectType;
  readonly softwareBoardCount: AGG$Long | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"HorizontalNavBoardHeader_project" | "ProjectHeader_project">;
  readonly " $fragmentType": "NavHeader_project";
};
export type NavHeader_project$key = {
  readonly " $data"?: NavHeader_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"NavHeader_project">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isTMPBoardRoute"
    }
  ],
  "kind": "Fragment",
  "name": "NavHeader_project",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "ProjectHeader_project"
    },
    {
      "kind": "FragmentSpread",
      "name": "HorizontalNavBoardHeader_project"
    },
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "projectType"
      },
      "action": "THROW",
      "path": "projectType"
    },
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "projectStyle"
      },
      "action": "THROW",
      "path": "projectStyle"
    },
    {
      "kind": "ScalarField",
      "name": "softwareBoardCount"
    },
    {
      "condition": "isTMPBoardRoute",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "kind": "LinkedField",
          "name": "mostRecentlyViewedBoard",
          "plural": false,
          "selections": [
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "kind": "FragmentSpread",
                  "name": "HorizontalNavBoardHeader_board"
                }
              ],
              "type": "JiraBoard"
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "e6f2c3a6daae909edfe8b5a8b679337c";

export default node;
